import * as THREE from 'three';

export class FormationData{


    public static list:FormationData[];

    public static Init(){

        FormationData.list = [

            new FormationData(2,1),//--2
            new FormationData(2,2),//--2
            new FormationData(2,3),//--2
            new FormationData(3,3),//8
            new FormationData(4,1),//2            
            new FormationData(4,2),//2
            new FormationData(4,3),//2
            new FormationData(3,4),//3
            new FormationData(3,2),//4
            new FormationData(5,2),//6
            new FormationData(5,3),
            new FormationData(6,1),
            new FormationData(6,2),
            new FormationData(7,1),                        
            new FormationData(8,2)
           
        ]

    }

    public numX:number;
    public numY:number;
    public amp:number = 3;

    constructor(numX:number,numY:number){

        this.numX = numX;
        this.numY = numY;
        this.amp = 0.4

    }


}